module.exports = __webpack_public_path__ + "img/icon-account.8ebb07b7.svg";